import React from 'react';
import { StyledButton } from './Button.styles';

const Button = ({ variant = 'primary', size = 'default', children, ...rest }) => (
  <StyledButton $variant={variant} $size={size} {...rest}>
    {children}
  </StyledButton>
);

export default Button;
